<template>
  <BaseLayout title="Preparing New Semester" :hideNavigation="true" :hideImpersonation="true">
    <div class="container py-5 d-flex flex-column align-items-center justify-content-center text-center" style="min-height: 60vh;">
      <div class="mb-4">
        <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <h1 class="h3 mb-3">Preparing the application for a new semester</h1>
      <p class="text-muted mb-4" style="max-width: 700px;">
        The app is closing the current semester and setting up a new one. This can take a while, especially if app archive data and files instead of just deleting them. <br />
        Please keep this page open.<br />
        You will be automatically redirected to the home page when the preparation is complete.
      </p>
      <div class="small text-muted" v-if="countdownSeconds > 0">
        Checking status in {{ countdownSeconds }}s…
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import BaseLayout from '@/components/BaseLayout.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'PreparingNewSemesterView',
  components: { BaseLayout },
  data() {
    return {
      pollIntervalId: null,
      countdownSeconds: 5,
      prevSemesterId: null,
    };
  },
  computed: {
    ...mapGetters(['semesterId']),
  },
  mounted() {
    this.prevSemesterId = window.sessionStorage.getItem('prevSemesterId');
    this.startPolling();
  },
  beforeUnmount() {
    this.stopPolling();
  },
  methods: {
    startPolling() {
      // Poll every 5 seconds: refresh token/user and redirect if semester present
      const tick = async () => {
        try {
          await this.$store.dispatch('refreshToken');
          // Redirect when semester changes or becomes available
          if (this.semesterId && String(this.semesterId) !== String(this.prevSemesterId || '')) {
            this.$router.replace('/');
          }
        } catch (e) {
          // ignore and retry
        } finally {
          this.countdownSeconds = 5;
        }
      };

      // Immediate tick then every 5s
      tick();
      this.pollIntervalId = setInterval(tick, 5000);

      // Local countdown to display seconds till next check
      const countdownTimer = setInterval(() => {
        if (this.countdownSeconds > 0) this.countdownSeconds -= 1;
        else this.countdownSeconds = 5;
        if (!this.pollIntervalId) clearInterval(countdownTimer);
      }, 1000);
    },
    stopPolling() {
      if (this.pollIntervalId) {
        clearInterval(this.pollIntervalId);
        this.pollIntervalId = null;
      }
    },
  },
};
</script>

<style scoped>
</style>